import { Box, Checkbox, Grid, Link, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import EirAddonsCard from '../eir-addons/EirAddonsCard';
import styles from './styles';
import EirInsuranceModal from './EirInsuranceModal';
import { useToggle } from '../../hooks/useToggle';

const EirInsuranceContainer = ({
  InsuranceHeading,
  SecurityHeading,
  InsuranceList,
  SecurityList,
  mobileAddOns,
  cards = mobileAddOns,
  mobileSecurityAddOns,
  showLoader,
  addAddon,
  removeAddOn,
  addMobileSecurityAddOn,
  removeMobileSecurityAddOn,
  insuranceAdded,
  insuranceAddedCheckbox,
  setInsuranceAddedCheckbox,
  dispatch,
}) => {
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const openInsuranceModal = useToggle(false);
  const openSecurityModal = useToggle(false);

  const handleCheckboxChange = event => {
    setInsuranceAddedCheckbox(event.target.checked);
    if (event.target.checked) {
      dispatch({ type: 'SET_INSURANCE_TERMS_CHECKED', payload: { status: false } });
    } else {
      dispatch({ type: 'SET_INSURANCE_TERMS_CHECKED', payload: { status: true } });
    }
  };

  useEffect(() => {
    if (cards?.length > 0) setLoading(false);
  }, [cards]);

  return (
    <>
      <Grid container xs={12} sm={12} sx={styles(theme).insuranceContainer}>
        {loading && (
          <>
            <EirAddonsCard card={[]} addAddon={() => {}} removeAddOn={() => {}} loading={loading} />
            <EirAddonsCard card={[]} addAddon={() => {}} removeAddOn={() => {}} loading={loading} />
          </>
        )}
        <Grid xs={12} sx={styles(theme).insuranceContainerCards}>
          {!loading &&
            mobileSecurityAddOns?.map((securityCard, index) => (
              <EirAddonsCard
                card={securityCard}
                key={index}
                addAddon={addMobileSecurityAddOn}
                removeAddOn={removeMobileSecurityAddOn}
                showLoader={showLoader}
                loading={loading}
                isHandset
                openInsuranceModal={openSecurityModal}
              />
            ))}
          {!loading &&
            cards?.map((card, index) => (
              <EirAddonsCard
                card={card}
                key={index}
                addAddon={addAddon}
                removeAddOn={removeAddOn}
                showLoader={showLoader}
                loading={loading}
                isHandset
                openInsuranceModal={openInsuranceModal}
              />
            ))}
        </Grid>
      </Grid>
      <Grid>
        {insuranceAdded && (
          <Box
            sx={
              mobileSecurityAddOns.length ? styles(theme).Checkbox : styles(theme).insuranceCardOnly
            }
          >
            <Stack direction='row' justifyContent='center' alignItems='flex-start' spacing={0}>
              <Checkbox
                sx={{
                  color: theme.palette.primary.textColor3,
                  p: '6px 8px',
                  '&.Mui-checked': {
                    color: theme.palette.primary.textColor3,
                  },
                  pl: 0,
                }}
                checked={insuranceAddedCheckbox}
                onChange={handleCheckboxChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />

              <Typography
                variant='body2'
                sx={{
                  color: theme.palette.primary.textColor3,
                  pl: 0,
                  pr: 1,
                  pt: 1,
                  pb: 1,
                }}
              >
                I confirm that I’ve read the &nbsp;
                <Link
                  href='https://www.eir.ie/opencms/export/sites/default/.content/pdf/terms/eirmobile/eir-Mobile-Insurance-Product-Information-Document.pdf'
                  passHref
                  target='_blank'
                  rel='noopener'
                  sx={styles(theme).insuranceLink}
                >
                  <Box
                    component='a'
                    aria-label='Insurance Product Information Document'
                    sx={{ color: theme.palette.primary.buttonColor }}
                  >
                    Insurance Product Information Document
                  </Box>
                </Link>
                &nbsp; and &nbsp;
                <Link
                  href='https://www.eir.ie/opencms/export/sites/default/.content/pdf/terms/eirmobile/eir-Mobile-Insurance-TCs.pdf'
                  passHref
                  target='_blank'
                  rel='noopener'
                  sx={styles(theme).insuranceLink}
                >
                  <Box
                    component='a'
                    aria-label='Terms and Conditions'
                    sx={{ color: theme.palette.primary.buttonColor }}
                  >
                    Terms & Conditions
                  </Box>
                </Link>
              </Typography>
            </Stack>
          </Box>
        )}
      </Grid>
      <EirInsuranceModal
        openInsuranceModal={openSecurityModal.value}
        handleClose={openSecurityModal.disable}
        disableCloseOnBackdropClick
        disableCloseOnEscapeKeyDown
        InsuranceHeading={SecurityHeading}
        InsuranceList={SecurityList}
      />
      <EirInsuranceModal
        openInsuranceModal={openInsuranceModal.value}
        handleClose={openInsuranceModal.disable}
        disableCloseOnBackdropClick
        disableCloseOnEscapeKeyDown
        InsuranceHeading={InsuranceHeading}
        InsuranceList={InsuranceList}
      />
    </>
  );
};

export default EirInsuranceContainer;
